import React from "react";
import { Label, Table } from "semantic-ui-react";
import useCustomerView from "@hooks/useCustomerView";
import { mapCustomerReviewStatus } from "@common/components/helpers/labels";
import {
  getSortDirection,
  handleCustomerSort,
} from "@common/components/helpers/sort";
import { getFormattedDate } from "../../common/components/helpers/datetime";
import { mapCustomerStatus } from "../../common/components/helpers/labels";

const CustomerTable = () => {
  const {
    headings,
    sortableColumns,
    records,
    selectedCustomer,
    activeViewTab,
    onCustomerClick,
    setState,
  } = useCustomerView();

  return (
    <div className="table-overflow flex-stretch-vertical">
      <Table celled sortable unstackable compact>
        <Table.Header>
          {headings.map((heading, index) => {
            return (
              <Table.HeaderCell
                key={`${heading.name}_${index}`}
                sorted={getSortDirection(sortableColumns, heading.value)}
                onClick={() =>
                  handleCustomerSort(sortableColumns, heading.value, setState)
                }
              >
                {heading.name}
              </Table.HeaderCell>
            );
          })}
        </Table.Header>
        <Table.Body>
          {records &&
            records.map((record) => {
              const status = mapCustomerReviewStatus(record);
              const state = mapCustomerStatus(record?.customer);
              return (
                <Table.Row
                  key={record.id}
                  className="clickable"
                  onClick={() =>
                    onCustomerClick({ selectedCustomer: record, activeViewTab })
                  }
                  active={record?.id === selectedCustomer?.id}
                >
                  <Table.Cell>
                    <Label color={status?.color} content={status?.content} />
                  </Table.Cell>
                  <Table.Cell>
                    <Label content={state} />
                  </Table.Cell>
                  <Table.Cell>
                    {record?.customer?.forename} {record?.customer?.surname}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    {record?.customer?.customerStats?.interactionCount}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    {record?.customer?.riskScore !== null
                      ? Number(record?.customer?.riskScore?.toFixed(1))
                      : "-"}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    {record?.customer?.customerStats?.cumulativeRiskScore !==
                    null
                      ? Number(
                          record?.customer?.customerStats?.cumulativeRiskScore.toFixed(
                            1,
                          ),
                        )
                      : "-"}
                  </Table.Cell>
                  <Table.Cell>{record?.site?.name}</Table.Cell>
                  <Table.Cell textAlign="right">
                    {record?.customer?.id}
                  </Table.Cell>
                  <Table.Cell>
                    {getFormattedDate(record?.customer?.lastUpdated)}
                  </Table.Cell>
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default CustomerTable;
